/* eslint-disable @typescript-eslint/no-unused-vars */
import { ButtonPrimeReact, DropdownPrimeReact } from "@finanedi.es/storybook"
import { GetAllImpuestosDtoProps } from "api/DTOs/GetAllImpuestosDto"
import { useImpuestoEmpresaNew } from "api/ImpuestoEmpresa.hook"
import { MODES_DOCUMENTOS } from "features/Crear/pages/FormCreacionDocumento/constant"
import { withFormik } from "formik"
import { InputNumber } from "primereact/inputnumber"
import { useTranslation } from "react-i18next"
import * as Yup from "yup"

const Retencion = ({
  handleSubmit,
  values,
  setFieldValue,
  onHide,
  isValid,
  valuesForm,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleSubmit: $TSMigrationFixMe
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values: $TSMigrationFixMe
  setFieldValue: (
    field: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: $TSMigrationFixMe,
    shouldValidate?: boolean
  ) => Promise<void>
  onHide: () => void
  isValid: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  valuesForm: $TSMigrationFixMe
}) => {
  const { t } = useTranslation()

  const { impuestoEmpresa } = useImpuestoEmpresaNew({
    EmpresaId: valuesForm?.empresaActiva?.id,
    TipoImpuestoEmpresa:
      valuesForm.documentoType.mode === MODES_DOCUMENTOS.VENTA ? 1 : 0,
    EsActivo: true,
    TipoGrupoImpuesto: 1,
    IsPagingEnabled: false,
  })

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete='off'
    >
      <div className='mb-2 p-fluid'>
        <div className='p-field'>
          <label htmlFor='retencion'>
            {t("crear.facturaRec.modal.holdLabel")}
          </label>
          <DropdownPrimeReact
            options={impuestoEmpresa?.items ?? []}
            value={values.retencionTipoId}
            onChange={(e) => {
              const taxSelected = impuestoEmpresa?.items?.find(
                (tax: GetAllImpuestosDtoProps) => tax.id === e.value
              )
              setFieldValue("retencionTipoId", e.value)
              setFieldValue(
                "retencionPorcentaje",
                taxSelected?.valor ? Math.abs(taxSelected?.valor) : null
              )
            }}
            optionLabel='nombre'
            optionValue='id'
            placeholder={`${t("impuestos.placeholderType")}`}
            panelClassName='!tw-z-50'
          />
          <InputNumber
            className='mt-2'
            disabled
            suffix='%'
            value={Math.abs(parseInt(values.retencionPorcentaje ?? 0, 10))}
            useGrouping={false}
          />
        </div>
      </div>

      <div className='tw-mt-4 tw-flex tw-h-10 tw-flex-row tw-justify-end tw-items-center'>
        <ButtonPrimeReact
          className='tw-mr-3 tw-h-10 tw-flex tw-justify-center tw-items-center !tw-text-text !tw-border-none !tw-bg-transparent tw-cursor-pointer hover:!tw-shadow'
          onClick={onHide}
        >
          {t("crear.facturaRec.modal.cancelButton")}
        </ButtonPrimeReact>
        <ButtonPrimeReact
          type='submit'
          disabled={!isValid}
          className='!tw-bg-primary tw-h-10 tw-flex tw-justify-center tw-items-center hover:!tw-shadow hover:!tw-bg-primary-over'
        >
          {t("crear.facturaRec.modal.addButton")}
        </ButtonPrimeReact>
      </div>
    </form>
  )
}

const validate = Yup.object().shape({
  retencionPorcentaje: Yup.number().required(),
})

const FormRetencionDocuemnto = withFormik({
  validationSchema: validate,
  validateOnMount: true,
  mapPropsToValues: ({
    retencionTipoId,
    retencionPorcentaje,
  }: // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any) => {
    return {
      retencionTipoId,
      retencionPorcentaje,
    }
  },
  handleSubmit: ({ retencionTipoId, retencionPorcentaje }, { props }) => {
    props.onChange({ retencionTipoId, retencionPorcentaje })
    props.onHide()
  },
})(Retencion)

export default FormRetencionDocuemnto
